//import manager from '@/utils/manager'
import api from '@/utils/api'

//获取折扣
export function getDiscountInfo(params)
{
    return api.post('wx/v1/official_account/discount', params)
}
